/**
 * Dynamic import for code splitting: https://webpack.js.org/guides/code-splitting/
 */
if (!window.MATERIO_UNSUPPORTED_BROWSER_DETECTED) {
  import('./register.jsx');
}
